import { fetchData } from "@client";

export async function getTeamRoleQuery() {
  try {
    const res = await fetchData("/team/role");
    return res.results;
  } catch (e) {
    return [];
  }
}
